import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  agents: [],
  currentAgent: null,
  loading: false,
  error: null,
};

const agentsSlice = createSlice({
  name: 'agents',
  initialState,
  reducers: {
    fetchAgentsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchAgentsSuccess: (state, action) => {
      state.loading = false;
      state.agents = action.payload;
    },
    fetchAgentsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    setCurrentAgent: (state, action) => {
      state.currentAgent = action.payload;
    },
  },
});

export const { fetchAgentsStart, fetchAgentsSuccess, fetchAgentsFailure, setCurrentAgent } = agentsSlice.actions;
export default agentsSlice.reducer;
